"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function InfoIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M12,21.057A9.057,9.057,0,1,1,21.056,12,9.066,9.066,0,0,1,12,21.057ZM12,4.643A7.357,7.357,0,1,0,19.357,12,7.366,7.366,0,0,0,12,4.643Z" }),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M12.906,16.794H11.094V11.005h1.812Z" }),
        react_1.default.createElement("path", { fillRule: "evenodd", d: "M10.758,8.417a1.149,1.149,0,0,1,.361-.867,1.3,1.3,0,0,1,1.763,0,1.152,1.152,0,0,1,.36.867,1.134,1.134,0,0,1-.36.851,1.3,1.3,0,0,1-1.763,0A1.131,1.131,0,0,1,10.758,8.417Z" })));
}
exports.default = InfoIcon;
